import Vue from "vue"
import { extend, localize } from "vee-validate";
// import { min, required, email, image, numeric }  from "vee-validate/dist/rules";
import * as rules from 'vee-validate/dist/rules';

import en from "vee-validate/dist/locale/en.json";
import { validate } from "vee-validate";
// import { setInteractionMode } from 'vee-validate';

// setInteractionMode('eager');
// Install rules
// extend('required', {
//     ...required,
//     message: 'The {_field_} field is required'
//   });


extend('date_format', {
    message: 'The {_field_} field is not valid',
    validate(value) {
        const parsed = moment(value, "DD-MM-YYYY", true).isValid();

        if (!parsed) return false;

        return true
    },
});

extend('mime_no_img', {
    message: 'ONLY audio and video are allowed',
    validate(value) {

        const sizeLimit = 104857600;
        let type = value[0].type;
        let size = value[0].size;
        if (type.includes('image') || type.includes('application')) {
            return false;
        }
        if (size > sizeLimit) {
            return false;
        }

        return true
    },
});

extend('mime', {
    message: 'File size exceed the 100M Limit',
    validate(value) {
        let size = value[0].size;

        if (size > 104857600) {
            return false;
        }

        return true
    },
});

extend('url', {
    validate(value) {
        if (value) {
            return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value);
        }

        return false;
    },
    message: 'The link must be a valid URL',
})
extend('duration', {
    validate(value) {
        if (value) {
            return /^([0-1]?[0-9]|[2][0-3]):([0-5][0-9])(:[0-5][0-9])?$/.test(value);
        }

        return false;
    },
    message: 'The duration must follow this format HH:MM:SS',
})


Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

// extend("min", min);
// extend("email", email);
// extend("image", image);

// Install messages
localize({
    en
});


Vue.use(validate)